import { NodeRenderer } from '@contentful/rich-text-react-renderer';
import ImageRender, { ImageRenderProps } from '../image-render/image-render';
import VideoRender from '../video-render/video-render';

/* eslint-disable-next-line */
export interface EmbeddedAssetProps {}

export const EmbeddedAsset = (({
    data: {
        target: { sys, fields },
    },
}) => {
    console.log('EmbeddedAsset', fields);

    const isVideo = fields.file.contentType.includes('video');
    if (isVideo) {
        return <VideoRender title={fields.title} youtubeVideoId={fields?.youtubeVideoId} url={fields?.file?.url} />;
    }

    const isImage = fields.file.contentType.includes('image');

    if (isImage) {
        return (
            <ImageRender
                // Change fields format to what <Image /> expects
                fields={{
                    title: fields.title,
                    image: { fields } as ImageRenderProps['fields']['image'],
                    description: fields.description,
                }}
            />
        );
    }

    // Ignore all other asset types, e.g. PDFs, other docs etc.
    return null;
}) as NodeRenderer;

export default EmbeddedAsset;
